import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["isTrellisCompatibleComponent", "hasAnyBorder", "onlyLeftAndRightBorders", "iconUse", "isToolbarActive"],
  _excluded2 = ["style", "height", "fontSize", "lineHeight", "hasAnyBorder", "onlyLeftAndRightBorders", "disabled", "isTrellisCompatibleComponent"];
import PropTypes from 'prop-types';
import { StyledIconButton } from './styledButtons';
import UIIcon from 'UIComponents/icon/UIIcon';
import { TOOLBAR_DROPDOWN_ICON_BUTTON_WIDTH } from './constants';
import { withNonTrellisComponent, withTrellisComponent } from '../withTrellisCompatibleHoc';
import ToolbarIconButton from './ToolbarIconButton';
import { DownCaratIcon } from 'foundations-assets';
import { jsx as _jsx } from "react/jsx-runtime";
const ToolbarDropdownIconButton = props => {
  if (props.isTrellisCompatibleComponent) {
    const {
        hasAnyBorder,
        onlyLeftAndRightBorders,
        iconUse,
        isToolbarActive
      } = props,
      rest = _objectWithoutPropertiesLoose(props, _excluded);
    return /*#__PURE__*/_jsx(ToolbarIconButton, Object.assign({}, rest, {
      hasAnyBorder: hasAnyBorder,
      icon: DownCaratIcon,
      isToolbarActive: isToolbarActive,
      onlyLeftAndRightBorders: onlyLeftAndRightBorders,
      use: iconUse,
      width: TOOLBAR_DROPDOWN_ICON_BUTTON_WIDTH
    }));
  }
  const {
      style = {},
      height,
      fontSize,
      lineHeight,
      hasAnyBorder,
      onlyLeftAndRightBorders,
      disabled = false
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded2);

  // Intentionally using the `fontSize` for the caret instead of the parent's `iconSize`
  // because the mocks keep the dropdown carat icon the same size even in toolbars
  // that have different icon sizes.
  const adjustedIconSize = fontSize - 3;
  const fontSizeForBetterVerticalCentering = 10;
  return /*#__PURE__*/_jsx(StyledIconButton, Object.assign({
    size: "xs",
    fontSize: fontSizeForBetterVerticalCentering,
    width: TOOLBAR_DROPDOWN_ICON_BUTTON_WIDTH,
    height: height,
    lineHeight: lineHeight,
    hasAnyBorder: hasAnyBorder,
    onlyLeftAndRightBorders: onlyLeftAndRightBorders,
    disabled: disabled,
    style: style
  }, rest, {
    children: /*#__PURE__*/_jsx(UIIcon, {
      name: "downCarat",
      size: adjustedIconSize
    })
  }));
};
ToolbarDropdownIconButton.propTypes = {
  height: PropTypes.number.isRequired,
  fontSize: PropTypes.number.isRequired,
  lineHeight: PropTypes.number.isRequired,
  hasAnyBorder: PropTypes.bool.isRequired,
  onlyLeftAndRightBorders: PropTypes.bool.isRequired,
  style: PropTypes.object
};
export const LegacyToolbarDropdownIconButton = withNonTrellisComponent(
// @ts-expect-error hoc doesn't play well with propTypes
ToolbarDropdownIconButton);
export const TrellisToolbarDropdownIconButton = withTrellisComponent(ToolbarDropdownIconButton);
export default LegacyToolbarDropdownIconButton;